var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUaLocationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#399",
  fillRule: "evenodd",
  d: "M11 .109c6.05 0 11 4.898 11 10.884 0 .762-.11 1.633-.22 2.395-.66 3.156-7.15 14.04-8.91 17.524C12.54 31.565 11.88 32 11 32c-.77 0-1.43-.435-1.76-.98 0-.108-.11-.108-.11-.217-2.31-4.354-7.15-12.19-8.58-16.436C.22 13.28 0 12.082 0 10.884 0 4.898 4.95 0 11 0zm0 5.66c2.75 0 4.95 2.177 4.95 4.898 0 2.72-2.2 4.898-4.95 4.898s-4.95-2.177-4.95-4.898c0-2.721 2.2-4.898 4.95-4.898",
  clipRule: "evenodd"
})));
export default SvgUaLocationIcon;